import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SearchStateService {
  private searchActiveSubject = new BehaviorSubject<boolean>(false);
  private searchResultsSubject = new BehaviorSubject<any[]>([]);
  private searchValueSubject = new BehaviorSubject<string>('');
  private searchLaunchedSubject = new BehaviorSubject<boolean>(false);

  searchActive$ = this.searchActiveSubject.asObservable();
  searchResults$ = this.searchResultsSubject.asObservable();
  searchValue$ = this.searchValueSubject.asObservable();
  searchLaunched$ = this.searchLaunchedSubject.asObservable();

  setSearchActive(active: boolean) {
    this.searchActiveSubject.next(active);
  }

  setSearchLaunched(launched: boolean) {
    this.searchLaunchedSubject.next(launched);
    if (launched) {
      this.setSearchActive(true);
    }
  }

  setSearchResults(results: any[]) {
    this.searchResultsSubject.next(results);
    const currentLaunched = this.searchLaunchedSubject.value;
    this.setSearchActive(currentLaunched || (results && results.length > 0));
  }

  setSearchValue(value: string) {
    this.searchValueSubject.next(value);
  }

  clear() {
    this.setSearchResults([]);
    this.setSearchValue('');
    this.setSearchLaunched(false);
    this.setSearchActive(false);
  }
}
